import { render } from "./BlacklistUpsetDialog.html?vue&type=template&id=0cc6c8b6&ts=true&external"
import script from "./BlacklistUpsetDialog.vue?vue&type=script&lang=ts"
export * from "./BlacklistUpsetDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__